import DonorNav from 'components/donor-details/DonorNav';
import { DonorContextProvider, useDonorContext } from 'context/donorContext';
import { getRelativePath } from 'helpers/utils';
import { useCallback, useEffect, useRef, useState } from 'react';
import {
  Navigate,
  Route,
  Routes,
  useParams
} from 'react-router-dom';
import paths from 'routes/paths';
import DonorCommunications from './DonorCommunications';
import DonorFeedback from './DonorFeedback';
import DonorDocuments from './documents/DonorDocuments';
import DonorGiftAid from './DonorGiftAid';
import DonorGiving from './DonorGiving';
import DonorGivingDetails from './DonorGivingDetails';
import DonorProfile from './DonorProfile';
import DonorRelationManagement from './DonorRelationManagement';
import DonorSponsorships from './DonorSponsorships';
import DonorSubscriptions from './DonorSubscriptions';
import { Col, Row } from 'react-bootstrap';
import ProfileCard from './ProfileCard';
import CardNav from './CardNav';
import ProfileInsights from './ProfileInsights';
import CreateDonation from 'components/add-donation';
import { useDonorNotesCount } from 'hooks/useDonors';

const DonorLayoutContent = () => {
  const parentRef = useRef(null);
  const navRef = useRef(null);
  const [isWidthReady, setIsWidthReady] = useState(false);
  const [isHeightReady, setIsHeightReady] = useState(false);

  const [parentWidth, setParentWidth] = useState(0);
  const [navHeight, setNavHeight] = useState(0);

  const parentRefCallback = useCallback(element => {
    parentRef.current = element;
    if (element) setIsWidthReady(true);
  }, []);

  const navRefCallback = useCallback(element => {
    navRef.current = element;
    if (element) setIsHeightReady(true);
  }, []);

  useEffect(() => {
    if (!isWidthReady) return;
    setParentWidth(parentRef?.current?.clientWidth);
    if (!isHeightReady) return;
    setNavHeight(navRef?.current?.clientHeight);
  }, [isWidthReady, isHeightReady]);

  const { id } = useParams();

  const { donor } = useDonorContext();
  const { notesCount } = useDonorNotesCount(id);

  return (
    <div
        className="position-relative mb-5"
        style={{
          padding: '0px !important'
        }}
        ref={parentRefCallback}
      >
        {/* <div className="position-absolute"> */}
        {parentWidth ? (
          <div
            id="top-bar"
            className="position-fixed "
            ref={navRefCallback}
            style={{
              zIndex: 2,
              // width: document.getElementById('parent').clientHeight
              width: parentWidth
            }}
          >
            <DonorNav notesCount={notesCount} />
          </div>
        ) : null}
        {/* </div> */}
        <div
          style={{
            paddingTop: navHeight ?? 0
          }}
        >
          <Row>
            <Col lg={3} xs={12}>
              <ProfileCard donorData={donor} />
              <CardNav notesCount={notesCount} />
            </Col>

            <Col lg={9} xs={12}>
              <Routes style={{ paddingTop: '100px' }}>
                <Route
                  path={getRelativePath(paths.donorProfile, paths.donorDetails)}
                  element={<DonorProfile />}
                />
                <Route
                  path={getRelativePath(
                    paths.donorInsights,
                    paths.donorDetails
                  )}
                  element={<ProfileInsights />}
                />
                <Route
                  path={getRelativePath(paths.donorGiving, paths.donorDetails)}
                  element={<DonorGiving />}
                />
                <Route
                  path={getRelativePath(
                    paths.donorGivingDetails,
                    paths.donorDetails
                  )}
                  element={<DonorGivingDetails />}
                />
                <Route
                  path={getRelativePath(
                    paths.donorSponsorships,
                    paths.donorDetails
                  )}
                  element={<DonorSponsorships />}
                />
                <Route
                  path={getRelativePath(
                    paths.donorSubscriptions,
                    paths.donorDetails
                  )}
                  element={<DonorSubscriptions />}
                />
                <Route
                  path={getRelativePath(
                    paths.donorCommunications,
                    paths.donorDetails
                  )}
                  element={<DonorCommunications />}
                />
                <Route
                  path={getRelativePath(
                    paths.donorRelationManagement,
                    paths.donorDetails
                  )}
                  element={<DonorRelationManagement />}
                />
                <Route
                  path={getRelativePath(paths.donorGiftAid, paths.donorDetails)}
                  element={<DonorGiftAid />}
                />
                <Route
                  path={getRelativePath(
                    paths.donorFeedback,
                    paths.donorDetails
                  )}
                  element={<DonorFeedback />}
                />
                <Route
                  path={getRelativePath(
                    paths.donorDocuments,
                    paths.donorDetails
                  )}
                  element={<DonorDocuments />}
                />
                <Route
                  path={
                    getRelativePath(paths.addNewDonation, paths.donorDetails) +
                    '/*'
                  }
                  element={<CreateDonation />}
                />

                <Route
                  path="*"
                  element={
                    <Navigate
                      to={getRelativePath(
                        paths.donorProfile,
                        paths.donorDetails
                      )}
                      replace
                    />
                  }
                />
              </Routes>
            </Col>
          </Row>{' '}
        </div>
      </div>
  );
};

const DonorLayout = () => {
  return (
    <DonorContextProvider>
      <DonorLayoutContent />
    </DonorContextProvider>
  );
};

export default DonorLayout;
